module.exports = __webpack_public_path__ + "static/media/Icon-ExecutiveP.c7e30ccd.png";